// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Lo-z","breadcrumbForward":"Mo-z","breadcrumbBack":"No-z","selected":"Oo-z"};